import { Component, HostListener, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { encryptWithKey } from '../../../shared/models/helper';
import { Defaultconfig } from '../../../shared/models/Defaultconfig';
import { Title } from '@angular/platform-browser';
import { CommunicationService } from '../../../services/communication.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { Utils } from 'src/app/shared/helpers/Utils';
import { ToastService } from 'src/app/services/toast/toast-service';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { FingerprintService } from 'src/app/services/fingerprint.service';
import { AuthService } from 'src/app/services/auth.service';
declare var $: any

@Component({
  selector: 'app-login-v2',
  templateUrl: './login-v2.component.html',
  styleUrls: ['./login-v2.component.scss']
})
export class LoginV2Component {
  @ViewChild('locationModal') locationModal!: ElementRef; 
  @ViewChild('emailInput') emailInput!: ElementRef;
  @ViewChild('passwordInput') passwordInput!: ElementRef;
  publicLoginInfo: any;
  loader: boolean = false;
  submitted = false;

  captcha = {
    enabled: false,
    site_key: '',
    verified: false,
    captcha_response: '',
  };
  emailPattern: any = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  mobilePattern: any = /^[0-9]{10}$/;
  loginForm: FormGroup = this.formBuilder.group({
    userType: [''],
    username: ['', Validators.required],
    mobile: ['', [Validators.required, Validators.pattern(this.mobilePattern)]],
    email: ['', [Validators.required, Validators.email, Validators.pattern(this.emailPattern)]],
    password: ['', [Validators.required]],
    remember_me: [false],
    captcha_response: [''],
  });
 
  latitude: any = '';
  longitude : any = '';
  isAuthenticationType : boolean = false 
  checkValue: boolean = true
  domainCheck: boolean = true
  bottomEnbale: boolean = true;
  request_id: string = '';
  provider_type: string = '';
  provider_name: string = '';
  view_type: string = '';
  client_id: string = '';
  flow_id: string = '';
  x_t_nbd_ref: string = '';
  logo_uri: any;
  isRegisterEnabled: boolean = false;
  isPasswordlessEnabled: boolean = false;
  isShowRememberMe: boolean = false;
  isErrorOccured: boolean = false;
  errorDescription: any;
  internalError: string = '';
  userValueTypes: any[] = [];
  queryParams: any = {};
  textOrPassword: string = 'password';
  password: any;
  show: boolean = false;
  showEmail: boolean = false;
  showMobile: boolean = false;
  showUsername: boolean = false;
  isNumberInput: boolean = false;
  isMailInput: boolean = false;
  is_federation_login: boolean = false;
  singleLeggedSettings: string[] = [];
  isSingleLeggedEnabled: boolean = false;
  usernameToEncrypt:any;
  login_provider_id: string = '';
  browser_fingerprint: string | null = null;
  //Responsive
  viewType: any;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.viewType = Defaultconfig.checkHostListenerEvent(event);
  }
  login_hint: any;
  classicTypeLogin: any = [];
  multipleClassicLogin: boolean = false;
  selectedClassicalProvider: any;
  is_false: boolean = false;
  providerLogin: any = [];
  passwordlessLogin: any = [];
  existsField: any;
  showClassicalLogin: boolean = false;
  submitLoader: boolean = false;
  userNameVar: any;
  passwordVar: any;
  captcha_response: any;
  showInvalidMobileError: boolean = false;

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.India, CountryISO.SaudiArabia];

  constructor(
    private toast: ToastService,
    private formBuilder: FormBuilder,
    private activateRoute: ActivatedRoute,
    private renderer: Renderer2,
    private titleService: Title,
    private communicationService: CommunicationService,
    private router: Router,
    private fingerprintService: FingerprintService,
    private authService: AuthService
  ) {
    this.request_id = this.activateRoute.snapshot.queryParams['request_id'];
    this.client_id = this.activateRoute.snapshot.queryParams['client_id'];
    this.login_hint = this.activateRoute.snapshot.queryParams['login_hint'];
    this.existsField = this.activateRoute.snapshot.queryParams['field_key'];
    this.x_t_nbd_ref = this.activateRoute.snapshot.queryParams['x_t_nbd_ref'];

    localStorage.setItem('x_t_nbd_ref', this.x_t_nbd_ref);

    let url: any = decodeURIComponent(this.login_hint).replace(/ /g, '+');
    //console.log('login_hint', decodeURIComponent(this.login_hint).replace(/ /g, '+'));
    // if (this.login_hint) {
    //   this.userNameVar = url;
    //   // this.loginForm.controls['email'].setValue(url);
    //   // let existsProvider: any = localStorage.getItem('existsProvider') ? JSON.parse(localStorage.getItem('existsProvider') as any) : '';
    //   // this.selectClasicProvider(existsProvider);
    // }
  }
  extractDomain(email: string): string {
    const domain = email.split('@')[1];
    return domain ? `@${domain}` : '';
  }
  async ngOnInit():  Promise<void> {
    this.request_id = this.activateRoute.snapshot.queryParams['request_id'];
    this.client_id = this.activateRoute.snapshot.queryParams['client_id'];
    this.provider_name = this.activateRoute.snapshot.queryParams['provider_name'];
    this.provider_type = this.activateRoute.snapshot.queryParams['provider_type'];
    this.flow_id = this.activateRoute.snapshot.queryParams['flow_id'];

    this.activateRoute.queryParams.subscribe(params => {
      this.queryParams = { ...params };
      this.request_id = this.queryParams['request_id'];
      this.client_id = this.queryParams['client_id'];
      this.flow_id = this.queryParams['flow_id'];
      this.provider_name = this.queryParams['provider_name'];
      this.provider_type = this.queryParams['provider_type'];
    });
    this.addGlobalEventListener();
    this.getViewType(); //Responsive
    this.password = 'password';
    this.loader = true;
    this.communicationService.publicLoginInfo$.subscribe(async data => {
      if (data && data != '') {
        this.loader = false;
        this.publicLoginInfo = data;
        this.bottomEnbale = true;
      }
      this.titleService.setTitle(this.publicLoginInfo?.display_settings?.display_name);
    });

    await this.authService.getPublicLoginInfo(this.request_id).subscribe((res:any) => {
      this.publicLoginInfo = res.data;
          if (this.publicLoginInfo?.geofencing_enabled) {
      this.showLocationPopup();
    }
      this.setLoginDetails();
      // console.log('check ', res.data)
    })
    this.communicationService.queryParams$.subscribe((data: any) => (this.queryParams = data));
    this.internalError = this.activateRoute.snapshot.queryParams['internal_error'];
    // console.log('internalError', this.internalError)
    this.captchaErrorCheck(this.internalError);
    localStorage.removeItem('otp_settings');
    
  }

  // ngAfterViewInit(): void {
  //   if (this.publicLoginInfo?.geofencing_enabled) {
  //     this.showLocationPopup();
  //   }
  //   // this.showLocationPopup();
  // }

  showLocationPopup(): void {
    if (this.locationModal) {
      this.renderer.setStyle(this.locationModal.nativeElement, 'display', 'block');
      this.locationModal.nativeElement.classList.add('show');
      this.renderer.addClass(document.body, 'modal-open');
    }
  }

  closeLocationModal(): void {
    if (this.locationModal) {
      this.renderer.setStyle(this.locationModal.nativeElement, 'display', 'none');
      this.locationModal.nativeElement.classList.remove('show');
      this.renderer.removeClass(document.body, 'modal-open');
    }
  }

  getLocation(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position: GeolocationPosition) => {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          // console.log("Latitude: " + this.latitude +
          //   "Longitude: " + this.longitude);
          // Dismiss the modal after getting location
          this.closeLocationModal();
        },
        (error: GeolocationPositionError) => {
          console.error("Error getting location: ", error);
          this.closeLocationModal();
        }
      );
    } else {
      this.closeLocationModal();
    }
  }

  isAuthenticationTypeValid() {
    // this.checkValue = false
    this.bottomEnbale = true;
    if (this.checkValue) {
      const validTypes = ['USER_IDENTIFIER_FIRST', 'USER_IDENTIFIER_FIRST_PASSWORD_LESS'];
      const authType = this.publicLoginInfo?.authentication_profile_settings?.authentication_profile_type;
      const isValid = validTypes.includes(authType)
      // console.log("Is Authentication Type Valid:", isValid);

      return isValid;
    }

    return false;
  }

  isAuthenticationTypeValidChek() {
    const isValid : boolean = true
    
    return isValid;
  }

  
  isAuthenticationPasswordType(): boolean {
    return this.publicLoginInfo?.authentication_profile_type === 'USER_IDENTIFIER_FIRST_PASSWORD';
  }
  checkDomain(): void {
    const email: string = this.loginForm.get('email')?.value || '';
    if(email != undefined) {
      this.userNameVar = email;
    }
    const domainType = this.publicLoginInfo?.authentication_profile_settings?.authentication_profile_type;
    const domainSettings = this.publicLoginInfo?.authentication_profile_settings?.domain_settings || [];
  
    // console.log("Domain Type:", domainType);
    // console.log("Domain Settings:", JSON.stringify(domainSettings));
    let currentArr = domainSettings.map((data: any) => ({
      domain: data.domain,
      provider: data.provider,
      provider_type: data.provider_type || null,
    }));

    
    let isValid = false;
    let providerToPass: any;

    for (const setting of currentArr) {
      if (email.endsWith(setting.domain.trim())) {
        isValid = true;
        providerToPass = setting.provider;
        break;
      }
    }

    if (isValid) {
    if (domainSettings.length > 0) {  
        // console.log("Email is valid with provider:", providerToPass);

        this.classicTypeLogin && this.classicTypeLogin.length > 1
  // Handle USER_IDENTIFIER_FIRST flow
if (domainType === 'USER_IDENTIFIER_FIRST' && 
  (this.publicLoginInfo?.authentication_profile_settings?.domain_settings.length > 0 || 
   this.publicLoginInfo?.authentication_profile_settings?.domain_settings.length === 1)) {

      // let matchedProvider = false;
      // Iterate over the classicTypeLogin array
      for (const set_login of this.classicTypeLogin) {
        if (set_login.provider_type ===  providerToPass.provider_type) {
          this.checkValue = true;
          this.showClassicalLogin = true;
          this.domainCheck = false;
          this.login_provider_id = providerToPass.login_provider_id;
          this.isAuthenticationTypeValid();
          this.selectClasicProvider(set_login); // Login with email
          // console.log("Login with email");
          // matchedProvider = true;
          break; // Exit the loop once a match is found
        } else if (set_login.provider_type === providerToPass.provider_type) {
          this.checkValue = true;
          this.showClassicalLogin = true;
          this.domainCheck = false;
          this.login_provider_id = providerToPass.login_provider_id;
          this.isAuthenticationTypeValid();
          this.selectClasicProvider(set_login); // Login with mobile
          // console.log("Login with mobile");
          // matchedProvider = true;
          break; // Exit the loop once a match is found
        }else {
          this.loginwithSocial(providerToPass);
        }
      }

      // If no match is found, fallback to social login
      // if (matchedProvider) {
      //   // console.log("No matching provider found for email or mobile, proceeding with social login.");
      //   this.loginwithSocial(providerToPass);
      // }

      return;
      }


  // else if (domainType === 'USER_IDENTIFIER_FIRST' && this.publicLoginInfo?.authentication_profile_settings?.domain_settings.length > 0) {
  //   // console.log("Handling USER_IDENTIFIER_FIRST flow");
  
  //   let matchedProvider = false;
  
  //   // Iterate over domain settings
  //   for (const domain of this.publicLoginInfo?.authentication_profile_settings?.domain_settings) {
  //     // Inner loop to iterate through classicTypeLogin
  //     for (const set_login of this.classicTypeLogin) {
  //       // Check if domain provider matches set_login provider
  //       if (domain.provider_type && set_login.provider_type) {
  //         this.checkValue = true;
  //         this.showClassicalLogin = true;
  //         this.domainCheck = false;
  //         this.login_provider_id = providerToPass.login_provider_id;
  //         this.isAuthenticationTypeValid();
  //         // console.log("Login with email");
  //         this.selectClasicProvider(set_login); // Pass the set_login to selectClasicProvider
  //         matchedProvider = true;
  //         break; // Exit inner loop after a match
  //       } else if (domain.provider_type && set_login.provider_type) {
  //         this.checkValue = true;
  //         this.showClassicalLogin = true;
  //         this.domainCheck = false;
  //         this.login_provider_id = providerToPass.login_provider_id;
  //         this.isAuthenticationTypeValid();
  //         // console.log("Login with mobile");
  //         this.selectClasicProvider(set_login); // Pass the set_login to selectClasicProvider
  //         matchedProvider = true;
  //         break; // Exit inner loop after a match
  //       }
  //     }
  
  //     // If a match was found, break the outer loop as well
  //     if (matchedProvider) {
  //       break; // Exit the outer loop
  //     }
  //   }
  
  //   // If no match was found, fallback to social login
  //   if (!matchedProvider) {
  //     // console.log("No matching provider found for email or mobile, proceeding with social login.");
  //     this.loginwithSocial(providerToPass);
  //   }
  
  //   return;
  // }

        else if (domainType === 'USER_IDENTIFIER_FIRST_PASSWORD_LESS' && providerToPass.provider_type == "PASSWORD_LESS") {
          // console.log("Handling USER_IDENTIFIER_FIRST_PASSWORD_LESS flow");
          this.passwordlessonSubmit(providerToPass.login_provider_id) 
        }
        else if (domainType === 'USER_IDENTIFIER_FIRST_PASSWORD_LESS' && (providerToPass.provider_type !== "PASSWORD_LESS" && providerToPass.provider_type != "CLASSICAL")) {
          // console.log("Handling USER_IDENTIFIER_FIRST_PASSWORD_LESS flow");
          this.loginwithSocial(providerToPass);
        }else if (domainType === 'USER_IDENTIFIER_FIRST_PASSWORD_LESS' && providerToPass.provider_type == "CLASSICAL") {
            // let matchedProvider = false;
            // Iterate over the classicTypeLogin array
            for (const set_login of this.classicTypeLogin) {
              if (set_login.provider_type === providerToPass.provider_type) {
                this.checkValue = true;
                this.showClassicalLogin = true;
                this.domainCheck = false;
                this.login_provider_id = providerToPass.login_provider_id;
                this.isAuthenticationTypeValid();
                // this.selectClasicProvider(set_login);
                // console.log("Login with email");
                // matchedProvider = true;
                break; // Exit the loop once a match is found
              } else if (set_login.provider_type === providerToPass.provider_type) {
                this.checkValue = true;
                this.showClassicalLogin = true;
                this.domainCheck = false;
                this.login_provider_id = providerToPass.login_provider_id;
                this.isAuthenticationTypeValid();
                // this.selectClasicProvider(set_login);
                // console.log("Login with mobile");
                // matchedProvider = true;
                break; // Exit the loop once a match is found
              } else {
                this.loginwithSocial(providerToPass);
              }
            }
      
            // // If no match is found, fallback to social login
            // if (!matchedProvider) {
            //   // console.log("No matching provider found for email or mobile, proceeding with social login.");
            //   this.loginwithSocial(providerToPass);
            // }
      
            return;
        }
      // } 
      // else {
      //   console.log("Email is not valid");
      // }
    } else {
       if (domainType === 'USER_IDENTIFIER_FIRST' && this.publicLoginInfo?.authentication_profile_settings?.domain_settings.length === 0 ) {
        this.checkValue = false;
        this.domainCheck = false;
      }
      else if (domainType === 'USER_IDENTIFIER_FIRST_PASSWORD_LESS' && this.publicLoginInfo?.authentication_profile_settings?.domain_settings.length === 0 ) {
        // console.log("Handling USER_IDENTIFIER_FIRST_PASSWORD_LESS flow");
        this.router.navigate(['/passwordless'], {
          queryParams: {
            request_id: this.queryParams.request_id,
            client_id: this.queryParams.client_id,
            provider_name: providerToPass.provider_name,
            provider_type: currentArr.find((d: { provider: any; }) => d.provider === providerToPass)?.provider_type || null,
          },
        });
      }
      // console.log("No domain settings available, proceeding with classic login flow.");
      // Handle classic login flow here
    }
      } 
      else {
        this.checkValue = true;
        this.showClassicalLogin = true;
        this.domainCheck = false;
        this.isAuthenticationTypeValid();
      }

  }
  
  onSubmit(): void {
    if (this.loginForm.controls['email'].valid) {
      this.submitLoader = true; // Show loader
      this.checkDomain();
      // Simulate a delay to hide the loader (e.g., after API call)
      setTimeout(() => {
        this.submitLoader = false;
      }, 1000); // Replace with your actual logic
    }
  }
  
  passwordlessonSubmit(id: any): void {
    this.submitLoader = true;
  
    // Define the POST URL
    const postLoginURL = Defaultconfig.GetAuthBaseURL() + 'login-srv/v2/login';
    const macRef = localStorage.getItem('x_t_nbd_ref');
  
    // Create the form element
    const form = this.renderer.createElement('form');
    form.action = postLoginURL;
    form.method = 'post';
  
    // Add x_t_nbd_ref parameter if available
    if (macRef) {
      const macRefInput = this.renderer.createElement('input');
      macRefInput.type = 'hidden';
      macRefInput.name = 'x_t_nbd_ref';
      macRefInput.value = macRef;
      this.renderer.appendChild(form, macRefInput);
    }
  
    // Add username parameter
    const usernameInput = this.renderer.createElement('input');
    usernameInput.type = 'hidden';
    usernameInput.name = 'username';
    usernameInput.value = this.loginForm.get('email')?.value;
    this.renderer.appendChild(form, usernameInput);
  
    // Add login_type parameter
    const loginTypeInput = this.renderer.createElement('input');
    loginTypeInput.type = 'hidden';
    loginTypeInput.name = 'login_type';
    loginTypeInput.value = 'password_less';
    this.renderer.appendChild(form, loginTypeInput);
  
    // Add request_id parameter
    const requestIdInput = this.renderer.createElement('input');
    requestIdInput.type = 'hidden';
    requestIdInput.name = 'request_id';
    requestIdInput.value = this.queryParams.request_id;
    this.renderer.appendChild(form, requestIdInput);
  
    // Handle single or multi-provider login
    const providerIdInput = this.renderer.createElement('input');
    providerIdInput.type = 'hidden';
    providerIdInput.name = 'login_provider_id';
    providerIdInput.value = id
    this.renderer.appendChild(form, providerIdInput);
  
    // Append the form to the document body
    this.renderer.appendChild(document.body, form);
  
    // Submit the form and clean up
    setTimeout(() => {
      form.submit();
      this.renderer.removeChild(document.body, form);
      this.submitLoader = false;
    }, 5000);
  }
  

  selectProvider(){
    this.selectedClassicalProvider = this.classicTypeLogin[0];
    // console.log('this.selectedClassicalProvider', this.selectedClassicalProvider)
  }
  selectClasicProvider(data: any) {
    //console.log('selected classifn provicewr loging using', data);
    localStorage.setItem('selectedProvider', JSON.stringify(data));
    this.selectedClassicalProvider = data;
    this.multipleClassicLogin = false;
    if (this.login_hint) this.setLoginHint();
  }
  moreLoginOption() {
    this.multipleClassicLogin = true;
    this.showClassicalLogin = false;
    // this.classicTypeLogin
  }
  getViewType() {
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (width <= 767) {
      this.viewType = 'mobile';
    } else {
      this.viewType = 'desktop';
    }
    //console.log('type', this.viewType);
  }
  onEnterPressed() {
    if (this.userNameVar && this.passwordVar) {
      this.onLoginSubmit();
    }
  }

  //mobile number validation
  validateMobileInput() {
    const mobileNumber = this.userNameVar;
    const phoneUtil = PhoneNumberUtil.getInstance();
    const number = phoneUtil.parseAndKeepRawInput(mobileNumber?.e164Number, mobileNumber?.countryCode);
    const isValidNumber = phoneUtil.isValidNumber(number);

    if (!isValidNumber) {
      this.showInvalidMobileError = true;
      return;
    } else {
      this.showInvalidMobileError = false;
    }
  }

  trackByFn(index: any, item: any) {
    return item.id;
  }

  get form() {
    return this.loginForm.controls;
  }
  onClickLoginCard() {
    const email = this.form['email'].value;
    const password = this.form['password'].value;

    if (email && password) {
      this.onLoginSubmit();
    }
  }
  addGlobalEventListener() {
    this.renderer.listen('document', 'keydown', (event) => {
      if (event.key === 'Enter') {
        const email = this.form['email'].value;
        const password = this.form['password'].value;
        if (email && password) {
          this.onLoginSubmit();
        }
      }
    });
  }
  setLoginDetails() {
    if (this.publicLoginInfo) {
      this.classicTypeLogin = [];
      this.passwordlessLogin = [];
      this.providerLogin = [];
      if (this.publicLoginInfo.enable_classical == false && this.publicLoginInfo.settings?.show_federation_login == true) {
        let url: any = Defaultconfig.getCurrentUrl() + '/federation-login?request_id=' + this.request_id + '&client_id=' + this.client_id;
        window.location.href = url;
      } else {

        if (this.publicLoginInfo.login_providers && this.publicLoginInfo.login_providers.length > 0) {
          //console.log('public login details ', this.publicLoginInfo)
          this.publicLoginInfo.login_providers.forEach(async (element: any) => {
            if (element.provider_type == "CLASSICAL") {
              this.classicTypeLogin.push(element);
              if (this.classicTypeLogin.length == 1) {
                if (this.login_hint) this.setLoginHint();
              }
              await this.selectProvider();
            } else if (element.provider_type == "PASSWORD_LESS") {
              this.passwordlessLogin.push(element)
            } else {
              this.providerLogin.push(element)
            }
          });
          if (this.classicTypeLogin.length > 1) {
            this.multipleClassicLogin = true;
            this.classicTypeLogin.forEach((ele: any) => {
              if (ele.classical_config) {
                if (this.existsField === ele.classical_config.username_variable) {
                  this.showClassicalLogin = true;
                  this.multipleClassicLogin = false;
                  this.selectedClassicalProvider = ele;
                }
              }
            });
          }
          //console.log('this.providerLogin', this.providerLogin)
        }

        if (this.publicLoginInfo.authentication_profile_settings.authentication_profile_type === 'USER_IDENTIFIER_FIRST_PASSWORD') {
          this.domainCheck = false;
        }

        this.is_federation_login = this.publicLoginInfo.settings?.show_federation_login;
        // this.logo_uri = Utils.convertToWebp(this.publicLoginInfo.display_settings?.logo_uri);
        this.logo_uri = this.publicLoginInfo.display_settings?.logo_uri;
        this.isRegisterEnabled = this.publicLoginInfo.settings?.show_register_option;
        this.isPasswordlessEnabled = this.publicLoginInfo.settings?.show_password_less_login;
        this.isShowRememberMe = this.publicLoginInfo.settings?.show_remember_me;
        this.userValueTypes = this.publicLoginInfo.allowed_username_types;
        this.showEmail = _.includes(this.userValueTypes, 'email');
        this.showMobile = _.includes(this.userValueTypes, 'mobile');
        this.showUsername = _.includes(this.userValueTypes, 'username');
        //console.log('Usernmae show=', this.showUsername);

        this.singleLeggedSettings = this.publicLoginInfo.single_legged_settings;
        if (this.singleLeggedSettings.length !== 0) {
          this.isSingleLeggedEnabled = true;
        }

        if (this.publicLoginInfo.captcha_settings && this.publicLoginInfo.captcha_settings.client_id && this.publicLoginInfo.captcha_settings.client_id != '') {
          this.captcha.site_key = this.publicLoginInfo.captcha_settings.client_id;
          // console.log(' this.captcha.site_key ',  this.captcha.site_key )
          if (this.internalError == 'captcha_required') {
            this.isErrorOccured = true;
            this.errorDescription = 'Captcha Required!';
            this.captcha.enabled = true;
          }
        }
      }
    }
    this.checkAndRedirectPasswordless();
  }

  checkAndRedirectPasswordless(): void {
    if (this.passwordlessLogin && this.passwordlessLogin.length === 1 && this.classicTypeLogin.length === 0 && this.providerLogin.length === 0) {
      this.router.navigate(['/passwordless'], {
        queryParams: {
          request_id: this.queryParams.request_id,
          client_id: this.queryParams.client_id,
          provider_name: this.queryParams.provider_name,
          provider_type: this.queryParams.provider_type,
          single_type: "single_passwordless_provider"
        }
      });
    }
  }

  setLoginHint() {
    if (this.classicTypeLogin.length == 1)
      this.classicTypeLogin.forEach((ele: any) => {
        if (ele.classical_config && ele.classical_config.username_variable_metadata) {
          if (ele.classical_config.username_variable_metadata.field_type == 'EMAIL') {
            this.userNameVar = this.login_hint;
          } else {
            this.userNameVar = '';
          }
        }
      });
    else if (this.classicTypeLogin.length > 1) {
      if (this.selectedClassicalProvider.classical_config.username_variable_metadata.field_type == 'EMAIL') {
        this.userNameVar = this.login_hint;
      } else {
        this.userNameVar = '';
      }
    }
  }

  singleRedirection() {
    const containsFace = this.singleLeggedSettings.includes('Face');
    const containsFIDO = this.singleLeggedSettings.includes('FIDO');

    if (containsFace && !containsFIDO && this.singleLeggedSettings.length === 1) {
      //console.log('Face..');
      this.router.navigate(['/otp-verification'], {
        queryParams: { request_id: this.request_id, client_id: this.client_id, mfa_type: 'FACE' },
      });
    } else if (!containsFace && containsFIDO && this.singleLeggedSettings.length === 1) {
      //console.log('fido');
      this.router.navigate(['/otp-verification'], {
        queryParams: { request_id: this.request_id, client_id: this.client_id, mfa_type: 'FIDO' },
      });
    } else if (containsFace && containsFIDO && this.singleLeggedSettings.length === 2) {
      this.router.navigate(['/single-legged'], {
        queryParams: { request_id: this.request_id, client_id: this.client_id },
      });
    } else {
      //console.log('invalid');
    }
  }

  // captchaErrorCheck(internal_error: string) {
  //   if (internal_error == 'user_blocked') {
  //     this.isErrorOccured = true;
  //     this.errorDescription = 'Your account has been blocked temporarily due to too many attempts! please try again later or contact administrator!';
  //   } else {
  //     let error = this.activateRoute.snapshot.queryParams['error'];
  //     this.errorDescription = this.activateRoute.snapshot.queryParams['error_description'];
  //     if (error && (error == 'invalid_request' || error == 'invalid_username_password')) {
  //       this.isErrorOccured = true;
  //     }
  //   }
  // }
  captchaErrorCheck(internal_error: string) {
    if (internal_error == 'user_blocked') {
      this.isErrorOccured = true;
      this.errorDescription = 'Your account has been blocked temporarily due to too many attempts! Please try again later or contact administrator.';
    } else {
      let error = this.activateRoute.snapshot.queryParams['error'];
      let error_description = this.activateRoute.snapshot.queryParams['error_description'];

      if (error && (error == 'invalid_request' || error == 'invalid_username_password')) {
        this.isErrorOccured = true;
        this.errorDescription = error_description;
      }

      if (internal_error == 'captcha_required') {
        this.isErrorOccured = true;
        this.errorDescription = 'Captcha Required!';
        this.captcha.enabled = true;
      }

      // if (error && (error.status == '401')) {
      //   this.isErrorOccured = true;
      //   this.errorDescription = 'Access Denied: You do not have permission to access this site';  

      // }
      // Ensure captcha site key is set
  if (this.captcha.enabled && this.publicLoginInfo?.captcha_settings?.client_id) {
    this.captcha.site_key = this.publicLoginInfo.captcha_settings.client_id;
  }
    }
  }

  onLoginSubmit() {

    this.fingerprintService.getVisitorId().subscribe(
      (visitorId : string) => {
        this.browser_fingerprint = visitorId;
        // console.log('Fingerprint inside subscribe:', this.browser_fingerprint);

    if (this.captcha.enabled && !this.captcha.verified) {
      this.isErrorOccured = true;
      this.errorDescription = 'Please verify the CAPTCHA before proceeding.';
      return; // Exit if CAPTCHA is not verified
    }
    this.submitLoader = true;
    const postLoginURL = Defaultconfig.GetAuthBaseURL() + 'login-srv/v2/login';
    const rememberMe = this.loginForm.get('remember_me')?.value;
    const macRef = localStorage.getItem('x_t_nbd_ref');
    const form = this.renderer.createElement('form');
    form.action = postLoginURL;
    form.method = 'post';
    form.style.display = 'none';
    const usernameInput = this.renderer.createElement('input');
    usernameInput.name = 'enc_username';

    const macRefInput = this.renderer.createElement('input');
    macRefInput.name = 'x_t_nbd_ref';
    macRefInput.value = macRef;
    this.renderer.appendChild(form, macRefInput);

    const rememberMeInput = this.renderer.createElement('input');
    rememberMeInput.name = 'remember_me';
    rememberMeInput.value = rememberMe.toString();
    this.renderer.appendChild(form, rememberMeInput);
    const passwordInput = this.renderer.createElement('input');
    passwordInput.name = 'enc_password';
    const fieldType = this.selectedClassicalProvider.classical_config.username_variable_metadata.field_type.toLowerCase();
    usernameInput.value = encryptWithKey(_.escape(this.usernameToEncrypt), this.queryParams.request_id);
    if (this.userNameVar?.e164Number) {
      usernameInput.value = encryptWithKey(_.escape(this.userNameVar?.e164Number), this.queryParams.request_id);
    } else {
      if (fieldType === 'email') {
        const enc_userNameVar = this.userNameVar.toLowerCase();
      usernameInput.value = encryptWithKey(_.escape(enc_userNameVar), this.queryParams.request_id);
      // usernameInput.value = encryptWithKey(_.escape(this.userNameVar), this.queryParams.request_id);
      }else{
       usernameInput.value = encryptWithKey(_.escape(this.userNameVar), this.queryParams.request_id);
      }
    }
    passwordInput.value = encryptWithKey(this.passwordVar, this.queryParams.request_id);
      // Add browser_fingerprint input
      const fingerprintInput = this.renderer.createElement('input');
      fingerprintInput.name = 'browser_fingerprint';
      fingerprintInput.value = this.browser_fingerprint || ''; // Use an empty string if fingerprint is null
      this.renderer.appendChild(form, fingerprintInput);
    // console.log('Usernamevalue',_.escape(this.userNameVar))
    // console.log('Usernamevalue -', _.escape(usernameInput.value) + 'password -', this.passwordVar)
    // single provider login
    if (this.classicTypeLogin && this.classicTypeLogin.length == 1) {
      let providerIdInput = this.renderer.createElement('input');
      providerIdInput.name = 'login_provider_id';
      if(this.login_provider_id !== '' && this.login_provider_id != null) {
        providerIdInput.value = this.login_provider_id;
      }
      else {
      providerIdInput.value = this.classicTypeLogin[0].login_provider_id;
    }
      this.renderer.appendChild(form, providerIdInput);
    }
    // // multi-provider login
    if (this.classicTypeLogin && this.classicTypeLogin.length > 1) {
      let providerIdInput = this.renderer.createElement('input');
      providerIdInput.name = 'login_provider_id';
      if(this.login_provider_id !== '' && this.login_provider_id != null) {
        providerIdInput.value = this.login_provider_id;
      }
      else {
      providerIdInput.value = this.selectedClassicalProvider.login_provider_id;
    }
      this.renderer.appendChild(form, providerIdInput);
    }
    const requestIdInput = this.renderer.createElement('input');
    requestIdInput.name = 'request_id';
    requestIdInput.value = this.queryParams.request_id;
    const providernameInput = this.renderer.createElement('input');
    providernameInput.name = 'provider_name';
    providernameInput.value = this.queryParams.provider_name;
    const providertypeInput = this.renderer.createElement('input');
    providertypeInput.name = 'provider_type';
    providertypeInput.value = this.queryParams.provider_type;
    this.renderer.appendChild(form, usernameInput);
    this.renderer.appendChild(form, passwordInput);
    this.renderer.appendChild(form, requestIdInput);
    if (this.queryParams.provider_name) {
      this.renderer.appendChild(form, providernameInput);
    }
    if (this.queryParams.provider_type) {
      this.renderer.appendChild(form, providertypeInput);
        }


        if (this.publicLoginInfo?.geofencing_enabled && this.latitude !== null && this.longitude !== null) {
          const geofence_data = this.renderer.createElement('input');
          geofence_data.name = 'geofence_data';

          const plainGeofenceValue = `[${this.longitude}, ${this.latitude}]`;
          const encryptedGeofenceValue = encryptWithKey(plainGeofenceValue, this.queryParams.request_id);

          geofence_data.value = encryptedGeofenceValue;
          this.renderer.appendChild(form, geofence_data);
        }

    this.renderer.appendChild(document.body, form);
    form.submit();
    setTimeout(() => {
      this.submitLoader = false;
    }, 5000);
      },
      (error) => {
        // console.error('Error getting fingerprint:', error);
        this.isErrorOccured = true;
        this.errorDescription = "Error getting browser fingerprint. Please try again.";
        this.submitLoader = false;
      }
    );
  }

  loginwithSocial(provider: any) {
    const macRef = localStorage.getItem('x_t_nbd_ref');
    let baseUrl = Defaultconfig.GetAuthBaseURL() + 'social-login-srv/v2/init/' + provider.provider_name + '/login/' + this.request_id;

    switch (provider?.provider_type) {
      case 'AD':
        window.location.href = `${baseUrl}/AD?x_t_nbd_ref=${macRef}`;
        break;
      case 'KERBEROS':
        window.location.href = `${baseUrl}/KERBEROS?x_t_nbd_ref=${macRef}`;
        break;
      case 'REST':
        window.location.href = `${baseUrl}/REST?x_t_nbd_ref=${macRef}`;
        break;
      case 'SAML':
        window.location.href = `${baseUrl}/SAML?x_t_nbd_ref=${macRef}`;
        break;
      default:
        window.location.href = `${baseUrl}?x_t_nbd_ref=${macRef}`;
        break;
    }
  }


  loginWithSaml(provider: any) {
    const macRef = localStorage.getItem('x_t_nbd_ref');
    window.location.href = Defaultconfig.GetAuthBaseURL() + 'social-login-srv/v2/init/' + provider + '/login/' + this.request_id + `/saml?x_t_nbd_ref=${macRef}`;
  }

  resolved(captchaResponse: any) {
    this.captcha.verified = true;
    //console.log(`Resolved captcha with response: ${captchaResponse}`);
    this.captcha.captcha_response = captchaResponse;
    this.loginForm.patchValue({
      captchaResponse: this.captcha.captcha_response,
    });
  }

  onClick() {
    if (this.selectedClassicalProvider.classical_config.password_variable_metadata.field_type.toLowerCase() === 'password') {
      this.selectedClassicalProvider.classical_config.password_variable_metadata.field_type = 'text';
      this.show = true;
    } else {
      this.selectedClassicalProvider.classical_config.password_variable_metadata.field_type = 'password';
      this.show = false;
    }
  }

  onClickOne() {
    if (this.classicTypeLogin && this.classicTypeLogin.length)
      if (this.classicTypeLogin[0].classical_config.password_variable_metadata.field_type.toLowerCase() === 'password') {
        this.classicTypeLogin[0].classical_config.password_variable_metadata.field_type = 'text';
        this.show = true;
      } else {
        this.classicTypeLogin[0].classical_config.password_variable_metadata.field_type = 'password';
        this.show = false;
      }
  }

  getInput() {
    this.isNumberInput = this.startsWithNumber(this.form['username'].value);
    this.isMailInput = this.includesString(this.form['username'].value);
  }

  startsWithNumber(str: any) {
    return /^\d/.test(str);
  }

  includesString(str: any) {
    return /[a-zA-Z]/g.test(str);
  }

  valid(): any {
    const captchaVerified = !this.captcha.enabled || this.captcha.verified;
    if (this.selectedClassicalProvider.classical_config.username_variable == 'email') {
      if (this.form['email'].value && !this.form['email'].errors?.['pattern'] && this.form['password'].value && captchaVerified) {
        return true;
      }
    } else if (this.selectedClassicalProvider.classical_config.username_variable == 'mobile') {
      if (this.form['mobile'].value && !this.form['mobile'].errors?.['pattern'] && this.form['password'].value && captchaVerified) {
        return true;
      };
    }
  }

  forgotPasswordRedirect() {
    const queryParams = {
      request_id: this.request_id,
      client_id: this.client_id,
      provider_name: this.selectedClassicalProvider.provider_name,
      provider_type: this.selectedClassicalProvider.provider_type,
      username_variable: this.selectedClassicalProvider.classical_config.username_variable,
      field_type: this.selectedClassicalProvider.classical_config.username_variable_metadata.field_type,
      display_name: this.selectedClassicalProvider.classical_config.username_variable_metadata.locale_text.display_name
    };
  
    // Pass queryParams directly without quotes
    this.router.navigate(['/forgot-password'], { queryParams: queryParams });
  }
  
}
